<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between mb-4">
      <div>
        <div class="section-title">{{ $t("property_in_out") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $t("property_in_out") }}
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between">
        <div>
          <!-- v-if="$can('create', 'Property In/Out')" -->
          <router-link
            variant="default"
            class="btn-blue"
            to="/fnb/add_property_in_out"
            >{{ $tc("add") }}</router-link
          >
        </div>
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row mb-3">
        <div class="col-lg-3 col-xl-3">
          <div class="dropdown-curve-container">
            <multiselect
              v-model="selectedCinema"
              label="cine_name"
              track-by="cine_id"
              :placeholder="$t('Cinema')"
              :options="cinemaList"
              @select="onSelectCinema($event)"
              @remove="onSelectCinema($event, 'remove')"
            >
              <span slot="noResult">Oops! No Results found.</span>
            </multiselect>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="input-material">
            <div class="add-datepicker">
              <button
                class="btn-clearDate"
                v-if="fromDate"
                v-on:click="fromDate = ''"
              >
                ✖
              </button>
              <Datepicker
                :monday-first="true"
                v-model="fromDate"
                ref="programaticOpen"
                :value="fromDate"
                typeable
                v-validate="'required'"
              ></Datepicker>
              <label :class="fromDate ? 'active' : ''">{{
                $t("fromdate")
              }}</label>
            </div>
          </div>
        </div>

        <div class="col-3">
          <b-form-input
            v-debounce:600="getPropertyInLogs"
            v-model="searchValue"
            type="search"
            placeholder="Search..."
          ></b-form-input>
        </div>

        <div class="col-lg-2">
          <button @click="getPropertyInLogs(false)" class="btn-blue w-100">
            Fetch
          </button>
        </div>

        <!-- <div
          v-if="propInOutLogs && propInOutLogs.length > 0"
          class="col-xl-12 d-flex justify-content-end align-items-center mt-3"
        >
          <div>{{ $t("download") }} as:</div>
          <a
            target="_blank"
            @click="getPropertyInLogs(null, 'Y')"
            title="Download as: "
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a>
        </div> -->
      </div>

      <!-- LIST VIEW  list-view-table-->
      <table class="list-view-table text-center border" border="1">
        <thead style="background: lightgrey">
          <tr>
            <th class="text-left p-2" style="width: 115px"></th>
            <th class="text-left p-2" style="width: 150px">{{ "Cinema" }}</th>
            <th class="text-left p-2" style="width: 150px">Order No.</th>
            <th class="text-left p-2" style="width: 150px">
              {{ $t("date") }}
            </th>
            <th class="text-left p-2" style="width: 150px">Created By</th>
            <th class="text-left p-2" style="width: 150px">
              {{ $tc("status", 1) }}
            </th>
          </tr>
        </thead>

        <tbody v-if="propInOutLogs.length > 0">
          <template v-for="(singleOrder, pindex) in propInOutLogs">
            <tr :key="singleOrder.pio_order_no + String(pindex)">
              <td class="text-left">
                <div
                  class="btn"
                  @click="showHideDetails(singleOrder)"
                  style="cursor: pointer"
                  v-b-tooltip="'View Items'"
                  tabindex="0"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="#4682B4"
                    class="bi bi-view-list"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H3zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2zm0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14z"
                    />
                  </svg>
                </div>
              </td>
              <td class="text-left">{{ singleOrder.cine_name || "-" }}</td>
              <td class="text-left">{{ singleOrder.pio_order_no }}</td>
              <td class="text-left">
                {{ singleOrder.created_at | dateparse }}
              </td>
              <td class="text-left">{{ singleOrder.username || "-" }}</td>
              <td class="text-left">{{ singleOrder.type }}</td>
            </tr>
            <tr
              :style="singleOrder.more ? '' : 'display: none'"
              :key="singleOrder.pio_order_no"
            >
              <td colspan="100%">
                <b-collapse v-model="singleOrder.more">
                  <table
                    class="list-view-table text-center"
                    style="width: 100%"
                  >
                    <thead>
                      <tr>
                        <th>{{ $tc("rawmaterials", 2) }}</th>
                        <th>{{ $t("quantity") }}</th>
                        <th>UOM</th>
                        <th>TYPE</th>
                        <th>REMARKS</th>
                      </tr>
                    </thead>

                    <tbody
                      v-if="
                        singleOrder.items_details &&
                        singleOrder.items_details.length > 0
                      "
                      class="m-0 p-0"
                      style="margin-bottom: 0"
                    >
                      <tr
                        v-for="(
                          singleItem, singleItemIndex
                        ) in singleOrder.items_details"
                        :key="singleItemIndex"
                      >
                        <td>
                          {{ singleItem.rm_name }}
                        </td>
                        <td>
                          {{ parseFloat(singleItem.qty || 0) }}
                        </td>
                        <td>
                          {{ singleItem.uom_short_form }}
                        </td>
                        <td>
                          {{ singleItem.type }}
                        </td>
                        <td>
                          {{ singleItem.remarks }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="5">
                          <NoRecords />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-collapse>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <b-pagination
      v-if="propInOutLogs.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      submitted: false,
      listView: true,
      propInOutLogs: [],
      Cinemas: [],
      selectedCinema: "",
      sm_id: "",
      searchValue: "",
      excelFile: null,
      fromDate: "",
      cinemaList: [],
      cinemaListCopy: [],
      searchCinema: "",
      obj: null,
      isRoleID: true,
      payloadBody: {
        cinema_id: null,
        selectedCinema: null,
        fromDate: new Date(),
        searchValue: null,
      },
    };
  },
  watch: {
    searchValue: function (newValue, oldValue) {
      if (String(newValue).length == 0) {
        this.searchValue = "";
        this.getPropertyInLogs();
      }
    },
  },
  mounted() {
    this.obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemas(this.obj);
    this.getPropertyInLogs();
  },
  beforeMount() {
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.obj = item.cine_id;
      this.searchCinema = "";
      this.onSearchCinema(null);
      this.getPropertyInLogs();
    },
    onSelectCinema(event, type) {
      if (type == "remove") {
        this.selectedCinema = "";
        this.obj = null;
      } else {
        this.selectedCinema = event;
        this.obj = event.cine_id;
      }
    },
    onSearch(event) {
      this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        if (String(this.searchValue || "").length > 4) {
          this.getPropertyInLogs();
        }
      }, 1500);
      // console.log('TO DO :>> ');
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getPropertyInLogs();
      } else {
        this.currentPage = event;
        this.getPropertyInLogs();
      }
    },
    getCinemas: function (cine_id) {
      let payload = null;
      cine_id == null
        ? (payload = { tableName: "ms_cinemas", cine_is_active: "Y" })
        : (payload = {
            tableName: "ms_cinemas",
            cine_is_active: "Y",
            cine_id: cine_id,
          });
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;

            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onSelectCinema({
                  cine_id: x.cine_id,
                  cine_name: x.cine_name,
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        });
    },
    clearSelectedDate: function () {
      this.stock_in_details.stock_in_moved_to_stock_date = "";
    },
    clearSelectedDate1: function () {
      this.stock_in_details.stock_in_expiry_date = "";
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
    showHideDetails: function (po) {
      if (po.hasOwnProperty("more")) {
        po.more = !po.more;
      } else po.more = true;

      this.propInOutLogs.forEach((p) => {
        if (po.po_id != p.po_id) {
          p.more = false;
        }
      });

      this.$forceUpdate();
    },
    getPropertyInLogs: function (
      isSkip = true,
      isExcelDownload = "N",
      isPdfDownload = "N"
    ) {
      console.log(this.searchValue, this.searchValue.length < 4, isSkip);
      if (this.searchValue && this.searchValue.length < 4 && isSkip) {
        return false;
      }
      let loader = this.$loading.show();

      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        cinema_id: this.obj,
        fromDate: this.fromDate,
        isExcelDownload: isExcelDownload || "N",
        isPdfDownload: isPdfDownload || "N",
      };
      PosFnbService.getPropertyInOutLogs(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.FinalExcelFile && isExcelDownload == "Y") {
            window.open(data.FinalExcelFile, "_blank");
          } else if (data && data.status && data.Records.length > 0) {
            this.propInOutLogs = data.Records;
            // this.excelFile = data.FinalExcelFile;
            if (data.totalCount >= 10) {
              this.rows = data.totalCount;
              this.selectedvalue =
                this.selectedvalue < 10 ? 10 : this.selectedvalue;
            } else {
              this.rows = data.totalCount;
              this.selectedvalue = data.totalCount;
            }
          } else {
            this.propInOutLogs = [];
            this.$toasted.show(data.message || "No Records Found");
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally((x) => setTimeout(() => loader.hide(), 1000));
    },
    onClose: function () {},
  },
};
</script>

<style ></style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/PropertyInOutComponents/listPropertyInOut.vue